import styled from "@emotion/styled"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material"
import * as api from "api"
import ExpandIcon from "common/icons/ExpandIcon"
import { memo } from "react"

const Styled = {
  Accordion: styled(Accordion)`
    &::before {
      display: none;
    }
    margin: 0 0 20px !important;
    background-color: ${(p) => p.theme.colors.paleGrey};
    border-top: 1.5px solid ${(p) => p.theme.colors.silver};
    border-bottom: 1.5px solid ${(p) => p.theme.colors.silver};
    &.Mui-expanded {
      background-color: transparent;
    }

    .MuiIconButton-edgeEnd {
      margin: 0;
    }
  `,
  Header: styled(Typography)`
    font-size: 16px;
    font-weight: bold;
    color: ${(p) => p.theme.colors.duskBlue};
    padding-inline-start: 20px;
    ${(p) => p.theme.breakpoints.up("md")} {
      font-weight: normal;
      font-size: 34px;
    }
  `,
  Details: styled.div`
    flex: 1;
    text-align: left; /* flipped for mui */
  `,
  Title: styled(Typography)`
    font-size: 16px;
    font-weight: bold;
    color: ${(p) => p.theme.colors.marine};
    ${(p) => p.theme.breakpoints.up("md")} {
      flex-basis: 150px;
      font-size: 18px;
    }
  `,
  Name: styled.span`
    display: inline-block;
    font-weight: bold;
    color: ${(p) => p.theme.colors.marine};
    :after {
      display: inline-block;
      content: "-";
    }

    :before {
      display: inline-block;
      content: "";
      width: 5px;
      height: 5px;
      margin-bottom: 2px;
      margin-inline-end: 10px;
      border-radius: 50%;
      background-color: ${(p) => p.theme.colors.marine};
    }
  `,
  Description: styled.span`
    display: inline-block;
    font-weight: normal;
    color: ${(p) => p.theme.colors.bluishGrey};
  `,
  Item: styled(Typography)`
    font-size: 12px;
    color: ${(p) => p.theme.colors.marine};
    :not(:first-of-type) {
      margin-top: 5px;
    }
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 16px;
    }
  `,
  Icon: styled(ExpandIcon)`
    height: 11px;
    width: 23.6px;
    ${(p) => p.theme.breakpoints.up("md")} {
      width: 45px;
      height: 21px;

      margin: 0 60px;
    }
  `,
  Items: styled.div`
    flex: 1;
  `,
  Grid: styled.div`
    display: flex;
    flex-direction: column;
    ${(p) => p.theme.breakpoints.up("md")} {
      flex-direction: row;
    }

    :not(:first-of-type) {
      margin-top: 33px;
    }
  `,
}

type VehicleFinishingLevelCategoriesProps = {
  data: api.VehicleFinishingLevelCategory[]
}

const VehicleFinishingLevelCategories = ({
  data,
}: VehicleFinishingLevelCategoriesProps) => {
  if (!data.length) return null

  return (
    <Styled.Accordion elevation={0}>
      <AccordionSummary expandIcon={<Styled.Icon />}>
        <Styled.Header>פרטים נוספים</Styled.Header>
      </AccordionSummary>
      <AccordionDetails>
        <Styled.Details>
          {data.map((category, i) => (
            <Styled.Grid key={i}>
              <Styled.Title>{category.name}</Styled.Title>
              <Styled.Items>
                {category.categoriesItems.map((item, i) => (
                  <Styled.Item key={i}>
                    <Styled.Name>{item.name}</Styled.Name>&nbsp;&nbsp;
                    <Styled.Description>{item.description}</Styled.Description>
                  </Styled.Item>
                ))}
              </Styled.Items>
            </Styled.Grid>
          ))}
        </Styled.Details>
      </AccordionDetails>
    </Styled.Accordion>
  )
}

export default memo(VehicleFinishingLevelCategories)
